import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedProducts from './components/FeaturedProducts';
import Categories from './components/Categories';
import LifestyleBanner from './components/LifestyleBanner';
import CollectionShowcase from './components/CollectionShowcase';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CouponPopup from './components/CouponPopup';
import PromoBanner from './components/PromoBanner';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <CouponPopup />
      <Header />
      <PromoBanner />
      <Hero />
      <Categories />
      <FeaturedProducts />
      <LifestyleBanner />
      <CollectionShowcase />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}